<template>
  <v-dialog
      :value="detailDialog"
      @click:outside="closeDetailDialog"
      max-width="600px"
      transition="dialog-transition"
      :v-bind="$attrs"
      :v-on="$listeners"
  >
    <v-card v-if="item" class="rounded-lg white">
      <v-card-title class="secondary back--text">
        {{ item.title }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="back secondary--text text-lg-end pt-2 pb-1">
        <span style="font-size: x-small " dir="ltr" class=" font-weight-light mr-2 ml-2">ساخته شده در</span>
        <span style="font-size: x-small " dir="ltr" class="font-weight-bold">{{ item.created_at }}</span>
        <span style="font-size: x-small " dir="ltr" class=" font-weight-light mr-2 ml-2">توسط</span>
        <span style="font-size: x-small " dir="ltr" class="font-weight-bold"> {{ item.created_by }}</span>
        <span style="font-size: x-small " dir="ltr" class=" font-weight-light mr-2 ml-2">در کسب و کار</span>
        <span style="font-size: x-small " dir="ltr" class="font-weight-bold">
          {{ item.notification.forwarder_company.name }}</span>
      </v-card-text>

      <v-card-text class="py-3">
        <p class="mt-5">
        <pre v-html="item.explanation"/>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            @click="changeStatus(item, 'r')"
            color="success white--text"
            class="w-100px rounded-lg"
            :disabled="item.status_codename == 'r'"
        >
          <v-icon class="white--text ml-3">fa-check-double</v-icon>

          خوانده شد
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NotificationDialog",
  props: {
    item: {
      required: true,
    },
    detailDialog: {},
  },
  data() {
    return {};
  },
  methods: {
    changeStatus(item, status_codename) {
      if (item.status_codename != status_codename) {
        this.request({
          url: this.endpoint("users/notifications/changeStatus"),
          method: "post",
          loading: false,
          data: {
            id: item.id,
            new_status: status_codename,
          },
          success: (data) => {
            let user = this.user;
            user.unread_notifications_count -= 1;
            this.$store.commit("setUser", user);

            this.closeDetailDialog();
            this.$emit("statusChanged");
          },
        });
      } else {
        this.closeDetailDialog();
      }
    },
    closeDetailDialog() {
      this.$emit('click:outside')
      this.$emit("update:detailDialog", false);
    },
  },
};
</script>

<style lang="scss">
pre {
  font-family: IRANSans !important;
  font-weight: normal;
}
</style>